import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import InvestmentIcon from "../Assets/Images/investment.svg";
import { notifyInAppError } from "../components/UtilitiesTS";
import { utility } from "../components/Utility";
import { auth } from "../redux/actions/Auth/Auth";
import { clientUser } from "../redux/actions/ClientUser/ClientUser";
import { ComplianceRedux } from "../redux/actions/Compliance/Compliance";
import { financial } from '../redux/actions/Financial/Investment';
import { notificationService } from "../redux/actions/Notification/Notification";
import { TwilioConversationsRedux } from "../redux/actions/TwilioConversations/TwilioConversations";
import { complianceConstants } from "../redux/constants/ComplianceConstant";
import { twilioConversationsConstants } from "../redux/constants/TwilioConversationsConstant";
import { useAppDispatchJS, useAppSelectorJS } from "../redux/hooks";
import { useAppDispatchTS, useAppSelectorTs } from "../redux/hooksTS";
import { reduxSelectUsersWhoCanAttemptCompliance, reduxSetHasComplianceAuth } from "../redux/slicesTS/ComplianceSlice";
import { reduxSetTesterStatus } from "../redux/slicesTS/UsersSlice";

const SideBar = ({ toggleMobileMenu, togglebtn }) => {
  let financialUrl = localStorage.getItem("financialUrl");
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setcollapsed] = useState(false);
  const [count, setCount] = useState();
  const sendbirdUnreadMessageCount = useAppSelectorJS((state) => state.UnreadMessageCount?.data?.unread_count);
  const [complianceUnreadMessageCount, setComplianceUnreadMessageCount] = useState(0)
  const [twilioUnreadChatMessageCount, setTwilioUnreadChatMessageCount] = useState(0)
  const [twilioUnreadTextMessageCount, setTwilioUnreadTextMessageCount] = useState(0)
  const unreadNotifcation = useAppSelectorJS((state) => state.NotificationCount);
  const dispatch = useAppDispatchJS();
  const dispatchTS = useAppDispatchTS();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );
  // const [calendarPreference, setCalendarPreference] = useState(false);
  const [docusignPreference, setDocusignPreference] = useState(false);
  const [filesPreference, setFilesPreference] = useState(false);
  const [messagePreference, setMessagePreference] = useState(false);
  const [chatPreference, setChatPreference] = useState(false);
  const [investmentTab, setInvestmentTab] = useState({});
  const MINUTE_MS = 30000;
  const UNREAD_MINUTE_MS = 30000;
  // Compliance
  const usersWhoCanAttemptComplianceAuth = useAppSelectorTs(reduxSelectUsersWhoCanAttemptCompliance);
  const hasComplianceAuth = useAppSelectorTs(state => state.compliance.hasComplianceAuth);

  // Compliance auth
  useEffect(() => {
    if (usersWhoCanAttemptComplianceAuth.includes(userDetails.email)) {
      dispatch(ComplianceRedux.GetComplianceAuth()).then(async response => {
        if (response && response.type === complianceConstants.GET_AUTH_SUCCESS) {
          dispatchTS(reduxSetHasComplianceAuth(true));
        } else if (response && response.type === complianceConstants.GET_AUTH_FAILURE) {
          notifyInAppError("Error with compliance auth: " + JSON.stringify(response.error.error));
        } else {
          notifyInAppError("Unknown error with compliance auth: " + JSON.stringify(response));
        }
      })
    } else {
      // User is not allowed to attempt compliance auth. Note: We still verify on the server side. We only check on client side to limit endpoint calls.
    }
  }, [userDetails, sendbirdUnreadMessageCount, twilioUnreadChatMessageCount, twilioUnreadTextMessageCount, setComplianceUnreadMessageCount]);
  // End of compliance auth

  // Tester auth:
  const currentUserTesterStatus = useAppSelectorTs(state => state.users.testerStatus);

  useEffect(() => {
    // Run the TC chat and text calls once to initially set the tester status
    dispatchTS(TwilioConversationsRedux.GetAllowedChatUsers()).then(async response => {
      if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_CHAT_USERS_SUCCESS) {
        // console.log('Allowed chat users', response.data.allowed_tc_chat_users);
        // console.log('Is current user allowed for chat: ', response.data.allowed_tc_chat_users.includes(currentUser.email));
        dispatchTS(reduxSetTesterStatus({ twilio_conversations_chat: response.data.allowed_tc_chat_users.includes(userDetails.email) }));
      } else if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_CHAT_USERS_FAILURE) {
        console.log('Error in getting allowed chat users');
      }
    });
    dispatchTS(TwilioConversationsRedux.GetAllowedTextUsers()).then(async response => {
      if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_TEXT_USERS_SUCCESS) {
        // console.log('Allowed text users', response.data.allowed_tc_text_users);
        // console.log('Is current user allowed for text: ', response.data.allowed_tc_text_users.includes(currentUser.email));
        dispatchTS(reduxSetTesterStatus({ twilio_conversations_text: response.data.allowed_tc_text_users.includes(userDetails.email) }));
      } else if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_TEXT_USERS_FAILURE) {
        console.log('Error in getting allowed text users');
      }
    });
    
    // Run this every 30 seconds to check if the current user is allowed to use Twilio Conversations chat or text
    const getAllowedTcUsers = async () => {
      dispatchTS(TwilioConversationsRedux.GetAllowedChatUsers()).then(async response => {
        if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_CHAT_USERS_SUCCESS) {
          // console.log('Allowed chat users', response.data.allowed_tc_chat_users);
          // console.log('Is current user allowed for chat: ', response.data.allowed_tc_chat_users.includes(currentUser.email));
          dispatchTS(reduxSetTesterStatus({ twilio_conversations_chat: response.data.allowed_tc_chat_users.includes(userDetails.email) }));
        } else if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_CHAT_USERS_FAILURE) {
          console.log('Error in getting allowed chat users');
        }
      });
      dispatchTS(TwilioConversationsRedux.GetAllowedTextUsers()).then(async response => {
        if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_TEXT_USERS_SUCCESS) {
          // console.log('Allowed text users', response.data.allowed_tc_text_users);
          // console.log('Is current user allowed for text: ', response.data.allowed_tc_text_users.includes(currentUser.email));
          dispatchTS(reduxSetTesterStatus({ twilio_conversations_text: response.data.allowed_tc_text_users.includes(userDetails.email) }));
        } else if (response && response.type === twilioConversationsConstants.GET_ALLOWED_TC_TEXT_USERS_FAILURE) {
          console.log('Error in getting allowed text users');
        }
      });
    };

    const setIntervalForAllowedTcUsers = setInterval(() => {
      getAllowedTcUsers();
    }, UNREAD_MINUTE_MS);

    return () => clearInterval(setIntervalForAllowedTcUsers);
  }, [userDetails, sendbirdUnreadMessageCount, twilioUnreadChatMessageCount, twilioUnreadTextMessageCount]);
  // End of tester auth

  useEffect(() => {
    updateInActivityTime();
    getGlobalNavPreferences(location.pathname);
    getNotification();
    getUnreadMessageCount();
  }, []);
  function frmatCount(count) {
    return count !== undefined ? (count <= 9 ? count : "9+") : "";
  }
  window.addEventListener("mousemove", (event) => {
    updateInActivityTime();
  });
  window.addEventListener("keydown", (event) => {
    updateInActivityTime();
  });

  function updateInActivityTime() {
    var currentdate = new Date();
    currentdate.setMinutes(currentdate.getMinutes() + userDetails?.session_timeout);
    localStorage.setItem('InActivityTime', currentdate.toString());
  }
  function frmatUnreadMessageCount(count) {
    return count !== undefined ? (count <= 9 ? count : "9+") : "";
  }
  useEffect(() => {
    if (unreadNotifcation) {
      setCount(
        frmatCount(
          unreadNotifcation?.data?.unread_count !== undefined
            ? unreadNotifcation?.data?.unread_count
            : unreadNotifcation?.data?.unread_notification_count
        )
      );
    } else {
      getNotification();
    }
  }, [unreadNotifcation]);

  function getNotification() {
    dispatch(notificationService.unreadNotificationsCount())
  }
  // to get notification count after every 30 seconds

  function getUnreadMessageCount() {
    var InActivityTime = new Date(localStorage.getItem('InActivityTime'));
    if (InActivityTime) {
      var currentdate = new Date();
      if (currentdate > InActivityTime) {
        utility.handleAuthError();
      }
    }
    dispatch(notificationService.getUnreadMessageCount())
  }

  function getTwilioUnreadMessageCountTotals() {
    dispatch(TwilioConversationsRedux.GetUserTotalUnreadMessageCounts(userDetails.twilio_conversations_user_identity)).then(async (response) => {
      if (response && response.type === twilioConversationsConstants.GET_USER_UNREAD_MESSAGE_COUNT_TOTALS_SUCCESS) {
        setTwilioUnreadChatMessageCount(response.data.unread_chat_count)
        setTwilioUnreadTextMessageCount(response.data.unread_text_count)
      } else if (response && response.type === twilioConversationsConstants.GET_USER_UNREAD_MESSAGE_COUNT_TOTALS_FAILURE) {
        notifyInAppError("Error getting unread message count: " + JSON.stringify(response.error.error));
      }
    });
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getUnreadMessageCount();
      getTwilioUnreadMessageCountTotals();
    }, UNREAD_MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getNotification();
    }, MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);

  // to get global nevigation preferences settings after every 30 seconds
  function getGlobalNavPreferences(currentRoute) {
    dispatch(auth.globalNavPreferences()).then((response) => {
      if (response.type === "GLOBAL_NAVIGATION_SUCCESS") {
        console.log('Global Nav Preferences', response.data)
        response.data.forEach((element) => {
          // if (element.preference_type === "calendar") {
          //   setCalendarPreference(element.value);
          //   if (element.value !== true && currentRoute === "/dashboard/calendar") {
          //     currentRoute = "/dashboard"
          //   }
          // } else 
          if (element.preference_type === "docusign") {
            setDocusignPreference(element.value);
            if (element.value !== true && currentRoute === "/dashboard/docu-sign") {
              currentRoute = "/dashboard"
            }
          } else if (element.preference_type === "files") {
            setFilesPreference(element.value);
            if (element.value !== true && currentRoute === "/dashboard/share-file") {
              currentRoute = "/dashboard"
            }
          } else if (element.preference_type === "message") {
            setMessagePreference(element.value);
            if (element.value !== true && currentRoute === "/dashboard/Messages") {
              currentRoute = "/dashboard"
            }
          } else if (element.preference_type === "chat") {
            setChatPreference(element.value);
            if (element.value !== true && currentRoute === "/dashboard/chat") {
              currentRoute = "/dashboard"
            }
          }
        });
        navigate(currentRoute);
      }
    });
  }

  useEffect(() => {
    onLocationChange();
  }, [location]);

  window.addEventListener(
    "resize",
    function (event) {
      let header = document.getElementsByTagName("header")[0].offsetHeight;
      let windowHeight = window.innerHeight;
      let sidebar = document.getElementsByClassName("sidemenu-wrap")[0];
      sidebar.style.height = windowHeight - (header + 48) + "px";
      onLocationChange();
    },
    true
  );

  function getFinancialUrl(household_id) {
    dispatch(financial.getFinancialUrl(household_id)).then((response) => {
      if (response.type === "GET_FINANCIALURL_SUCCESS") {
        if (response.data) {
          localStorage.setItem("financialUrl", response.data.redirect_url);
        }
        else {
          localStorage.setItem("financialUrl", 'Invalid');
        }
      }
    })
  }


  useEffect(() => {
    setTimeout(() => {
      if (document.getElementsByTagName("header")[0]) {
        let header = document.getElementsByTagName("header")[0].offsetHeight;
        let windowHeight = window.innerHeight;
        let sidebar = document.getElementsByClassName("sidemenu-wrap")[0];
        sidebar.style.height = windowHeight - (header + 48) + "px";
      } else {
        let sidebar = document.getElementsByClassName("sidemenu-wrap")[0];
        if (sidebar.style.height){
          sidebar.style.height = "100vh";
        }
      }
    }, 200);
    if (userDetails?.user_type === "clients") {
        getInvestmentToggleButtonPermission();
    }
  }, [userDetails]);


  function getInvestmentToggleButtonPermission() {
    dispatch(clientUser.getInvestmentToggleButtonPermission(userDetails?.household_sf_id, userDetails?.uuid)).then((response) => {
      if (response.type === "GET_INVESTMENT_TOGGLE_BUTTON_PERMISSION_SUCCESS") {
        // setInvestmentToggle(response?.data?.user_obj)
        setInvestmentTab(response?.data)
        if (!financialUrl && response?.data?.toggle_allowed) {
          getFinancialUrl(response?.data?.orion_hh_id)
        }
        else {
          localStorage.removeItem("financialUrl")
          if (location.pathname === "/dashboard/financial") {
            window.location = "/dashboard";
          }

          getFinancialUrl(response?.data?.orion_hh_id)
        }
      }
      else {
        if (location.pathname === "/dashboard/financial") {
          window.location = "/dashboard";
        }
      }
    });
  }

  function onLocationChange() {
    setTimeout(() => {
      if (document.getElementsByTagName("header")[0] && document.getElementsByClassName("heading-wrap")[0]) {
        let header = document.getElementsByTagName("header")[0].offsetHeight;
        let pageHeader =
          document.getElementsByClassName("heading-wrap")[0].offsetHeight;
        let value = getInnerHeader();
        let windowHeight = window.innerHeight;
        try {
          if (value !== null && value.body !== null) {
            if (value.body.style === null) return;
            value.body.style.height = windowHeight - (header + pageHeader + value.innerHeader) + "px";
          }
        } catch (error) {
          console.log("Error in onLocationChange header/page auto adjustment", error);
        }
      } else {
        let value = getInnerHeader();
        let windowHeight = window.innerHeight;
        try {
          if (value !== null && value.body !== null) {
            if (value.body.style === null) return;
            value.body.style.height = windowHeight - value.innerHeader + "px";
          }
        } catch (error) {
          console.log("Error in onLocationChange header/page auto adjustment", error);
        }
      }
    }, 400);
  }

  function getInnerHeader() {
    let loc = location.pathname?.substring(
      location.pathname?.lastIndexOf("/") + 1
    );
    switch (loc) {
      case "Messages":
        return {
          innerHeader: 0,
          body: document.getElementsByClassName("message-wrapper")[0],
        };
      case "docu-sign":
        return {
          innerHeader:
            document.getElementsByClassName("tab-wrap")[0].offsetHeight,
          body: document.getElementsByClassName("content-area")[0],
        };
      case "Conversations":
        return {
          innerHeader:
            document.getElementsByClassName("tab-wrap")[0].offsetHeight,
          body: document.getElementsByClassName("twilio-conversations-content"),
        };
      // case "calendar":
      //   if (document.getElementsByClassName("calendar-topbar")[0]
      //     && document.getElementsByClassName("calendar-wrap")[0]
      //     && document.getElementsByClassName("calendar-topbar")[0].offsetHeight
      //   ) {
      //     return {
      //       innerHeader: document.getElementsByClassName("calendar-topbar")[0].offsetHeight,
      //       body: document.getElementsByClassName("calendar-wrap")[0],
      //     };
      //   }
      //   return null;
      case "profile":
        return {
          innerHeader: 0,
          body: document.getElementsByClassName("content-area")[0],
        };
      default:
        return null;
    }
  }

  return (
    <>
      <div className={"sidebar-outer " + (toggleMobileMenu ? "open" : "")}>
        <div className="mobilemenu-overlay" onClick={() => togglebtn()}></div>
        <div className={"sidebar " + (collapsed ? "collapsed" : "")}>
          <div className="sidemenu-wrap">
            <div className="collapse-div">
              <ul className="main-nav">
                {/* Use the beta tag for any new features */}
                {/* <span className="beta-tag">Beta</span> */}
                <li>
                  <a
                    className="cursor-pointer d-none d-lg-flex"
                    onClick={() => setcollapsed(!collapsed)}
                  >
                    <span className="menu-icon">
                      <em className="icon-double-arrow-left-outline"></em>
                    </span>
                    <span className="long">Collapse</span>
                    <span className="short">Expand</span>
                  </a>
                  <a
                    className="cursor-pointer d-lg-none"
                    onClick={() => togglebtn()}
                  >
                    <span className="menu-icon">
                      <em className="icon-double-arrow-left-outline"></em>
                    </span>
                    <span>Collapse</span>
                  </a>
                </li>
              </ul>
            </div>
            <ul className="main-nav main-menu custom-style-scroll">
              <li >
                <Link
                  className={location.pathname === "/dashboard" ? "active" : ""}
                  to="/dashboard"
                  onClick={(e) => {
                    if (userDetails?.user_type === "clients") {
                      e.preventDefault();
                      getGlobalNavPreferences("/dashboard")
                    }
                  }}
                >
                  <span className="menu-icon">
                    <em className="icon-home-filled"></em>
                  </span>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  style={{ position: "relative" }}
                  className={
                    location.pathname === "/dashboard/notification"
                      ? "active"
                      : ""
                  }
                  to="/dashboard/notification"
                  onClick={(e) => {
                    if (userDetails?.user_type === "clients") {
                      e.preventDefault();
                      getGlobalNavPreferences("/dashboard/notification")
                    }
                  }}
                >
                  <span className="menu-icon">
                    <em className="icon-bell-filled"></em>
                  </span>
                  Notification
                  {count !== undefined && parseInt(count) > 0 && (
                    <>
                      <span className="short short-notifc-number notifc-number ml-5">
                        {count}
                      </span>
                      <span className="long notifc-number ml-5">
                        {count}
                      </span>
                    </>
                  )}
                </Link>
              </li>
              <li>
                {(messagePreference === true || messagePreference === "true") && (
                  <Link
                    style={{ position: "relative" }}
                    className={
                      location.pathname === "/dashboard/Messages"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/Messages"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        getGlobalNavPreferences("/dashboard/Messages")
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <em className="icon-chat-alt-2-filled"></em>
                    </span>
                    Messages
                    {sendbirdUnreadMessageCount !== undefined && parseInt(sendbirdUnreadMessageCount) > 0 &&
                      <><span className="short ms-auto short-notifc-number notifc-number">{frmatUnreadMessageCount(sendbirdUnreadMessageCount)}</span>
                        <span className="long ms-auto notifc-number">{frmatUnreadMessageCount(sendbirdUnreadMessageCount)}</span>
                      </>
                    }
                  </Link>
                )}
              </li>
              <li>
                {userDetails?.user_type === "advisors" && (chatPreference === true || chatPreference === "true") && currentUserTesterStatus.twilio_conversations_text && (
                  <Link
                    style={{ position: "relative" }}
                    className={
                      location.pathname === "/dashboard/text"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/text"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        getGlobalNavPreferences("/dashboard/text")
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <em className="icon-chat-alt-2-filled"></em>
                    </span>
                    Text
                    {twilioUnreadTextMessageCount !== undefined && parseInt(twilioUnreadTextMessageCount) > 0 &&
                      <>
                        <span className="short ms-auto short-notifc-number notifc-number">{frmatUnreadMessageCount(twilioUnreadTextMessageCount)}</span>
                        <span className="long ms-auto notifc-number">{frmatUnreadMessageCount(twilioUnreadTextMessageCount)}</span>
                      </>
                    }
                  </Link>
                )}
              </li>
              <li>
                {(chatPreference === true || chatPreference === "true") && currentUserTesterStatus.twilio_conversations_chat && (
                  <Link
                    style={{ position: "relative" }}
                    className={
                      location.pathname === "/dashboard/chat"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/chat"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        getGlobalNavPreferences("/dashboard/chat")
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <em className="icon-chat-alt-2-filled"></em>
                    </span>
                    Chat
                    <span className="beta-tag">Beta</span>
                    {twilioUnreadChatMessageCount !== undefined && parseInt(twilioUnreadChatMessageCount) > 0 &&
                      <>
                        <span className="short ms-auto short-notifc-number notifc-number">{frmatUnreadMessageCount(twilioUnreadChatMessageCount)}</span>
                        <span className="long ms-auto notifc-number">{frmatUnreadMessageCount(twilioUnreadChatMessageCount)}</span>
                      </>
                    }
                  </Link>
                )}
              </li>
              <li>
                {(investmentTab?.toggle_allowed) && (
                  <Link
                    className={
                      location.pathname === "/dashboard/financial"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/financial"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        navigate("/dashboard/financial", { state: { orion_hh_id: investmentTab?.orion_hh_id, orion_hh_name: investmentTab?.orion_hh_name } })
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <img src={InvestmentIcon} alt="" />
                    </span>
                    Investments
                  </Link>
                )}
              </li>
              {/* <li>
                {(calendarPreference === true || calendarPreference === "true") && (
                  <Link
                    className={
                      location.pathname === "/dashboard/calendar"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/calendar"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        getGlobalNavPreferences("/dashboard/calendar")
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <em className="icon-calendar-filled"></em>
                    </span>
                    Calendar
                  </Link>
                )}
              </li> */}
              <li>
                {(docusignPreference === true || docusignPreference === "true") && (
                  <Link
                    className={
                      location.pathname === "/dashboard/docu-sign"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/docu-sign"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        getGlobalNavPreferences("/dashboard/docu-sign")
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.5 2.4C0.5 1.0725 1.5725 0 2.9 0H8.405C9.0425 0 9.65 0.255 10.1 0.705L14.195 4.8C14.3124 4.91736 14.4165 5.04544 14.5062 5.18197L10.0244 13.2317C9.92864 13.4036 9.90432 13.6063 9.95663 13.796L10.8915 17.1859C11.0042 17.5943 11.4325 17.8284 11.837 17.7027L14.9 16.7513V16.8C14.9 18.1275 13.8275 19.2 12.5 19.2H2.9C1.5725 19.2 0.5 18.1275 0.5 16.8V2.4ZM8.777 17.9644C8.82927 17.9911 8.89895 18 8.95993 18L8.92509 17.9911C9.04704 17.9911 9.16028 17.9466 9.2561 17.8754C9.35192 17.8041 9.43031 17.6973 9.46516 17.5815C9.5 17.5103 9.5 17.4302 9.5 17.3501C9.5 17.2699 9.48258 17.1987 9.44773 17.1275C9.4216 17.0562 9.36934 16.9939 9.31707 16.9405C9.26481 16.8871 9.19512 16.8515 9.12544 16.8248C8.74216 16.62 8.43728 16.2728 8.27178 15.8543L8.26982 15.8508C8.07006 15.4957 7.86101 15.1241 7.44425 15.0886C7.33101 15.0797 7.21777 15.1064 7.11324 15.1509C7.00871 15.1955 6.91289 15.2667 6.84321 15.3557V15.3112C6.87805 14.8482 6.90418 14.314 6.38153 14.0202C5.84146 13.7175 5.17073 14.1271 4.53484 14.6256C4.33449 14.7948 3.94251 15.053 3.70732 14.9284C3.39373 14.7592 3.1324 13.9401 3.1324 13.1121C3.1324 11.3225 3.6115 9.47951 4.54355 9.43499C4.6655 9.41719 4.79617 9.42609 4.91812 9.4617C5.04007 9.49732 5.15331 9.55964 5.24913 9.64867C5.50174 9.90687 5.6324 10.4144 5.6324 11.1533C5.64112 11.3047 5.7108 11.4471 5.81533 11.5451C5.92857 11.6519 6.06794 11.7053 6.20732 11.7053C6.34669 11.7053 6.48606 11.643 6.59059 11.5451C6.69512 11.4382 6.76481 11.3047 6.77352 11.1533C6.77352 10.7527 6.77352 9.52403 6.04181 8.79395C5.83275 8.59808 5.58885 8.44672 5.31882 8.35769C5.05749 8.25975 4.77003 8.23304 4.49129 8.25975C2.65331 8.34879 2 10.8239 2 13.121C2 14.1627 2.31359 15.5338 3.20209 16.0146C3.62021 16.2104 4.29965 16.3084 5.23171 15.5872C5.3885 15.4626 5.55401 15.3557 5.71951 15.2489V15.418C5.67596 15.6228 5.66725 15.8365 5.7108 16.0502C5.74564 16.2549 5.82404 16.4508 5.94599 16.6289C6.08537 16.7802 6.25958 16.8604 6.45122 16.8782C6.61672 16.896 6.78223 16.8782 6.93902 16.8248C7.09582 16.7713 7.23519 16.6823 7.35714 16.5666C7.6446 17.1987 8.14983 17.6973 8.777 17.9644Z"
                          fill="#D3D6DE"
                        />
                        <path
                          d="M20.45 0.967512C20.27 0.862512 20.0675 0.795012 19.8575 0.772512C19.6475 0.750012 19.4375 0.772512 19.235 0.825012C19.0325 0.885012 18.845 0.982512 18.68 1.11751C18.515 1.25251 18.38 1.41751 18.275 1.60501L18.11 1.90501L20.8925 3.49501L21.0575 3.19501C21.2675 2.82001 21.32 2.37001 21.2075 1.95751C21.095 1.53751 20.825 1.18501 20.45 0.975012V0.967512Z"
                          fill="#D3D6DE"
                        />
                        <path
                          d="M11.2849 14.13L11.8474 16.4325L14.0824 15.72L20.1874 4.74748L17.3899 3.16498L11.2849 14.13Z"
                          fill="#D3D6DE"
                        />
                      </svg>
                    </span>
                    DocuSign
                  </Link>
                )}
              </li>
              <li>
                {(filesPreference === true || filesPreference === "true") && (
                  <Link
                    className={
                      location.pathname === "/dashboard/share-file"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/share-file"
                    onClick={(e) => {
                      if (userDetails?.user_type === "clients") {
                        e.preventDefault();
                        getGlobalNavPreferences("/dashboard/share-file")
                      }
                    }}
                  >
                    <span className="menu-icon">
                      <em className="icon-folder-filled"></em>
                    </span>
                    Files
                  </Link>
                )}
              </li>
              <li>
                {userDetails?.user_type === "advisors" && (
                  <Link
                    className={
                      location.pathname === "/dashboard/client-user"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/client-user"

                  >
                    <span className="menu-icon">
                      <em className="icon-user-circle-filled"></em>
                    </span>
                    Client Users
                  </Link>
                )}
              </li>
              <li>
                {userDetails?.user_type === "advisors" && (
                  <Link
                    className={
                      location.pathname ===
                        "/dashboard/content-distribution-center"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/content-distribution-center"

                  >
                    <span className="menu-icon">
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.47796 0H18.2857C19.2324 0 20 0.755516 20 1.6875V14.625C20 16.489 18.465 18 16.5714 18H4C4.47349 18 4.76367 17.2948 4.76367 16.4598V1.6875C4.76367 0.755516 5.53125 0 6.47796 0ZM8.28572 12.375C7.81236 12.375 7.42857 12.7528 7.42857 13.2188C7.42857 13.6847 7.81236 14.0625 8.28572 14.0625H16.2857C16.7591 14.0625 17.1429 13.6847 17.1429 13.2188C17.1429 12.7528 16.7591 12.375 16.2857 12.375H8.28572ZM7.42857 10.4062C7.42857 9.94029 7.81236 9.5625 8.28572 9.5625H16.2857C16.7591 9.5625 17.1429 9.94029 17.1429 10.4062C17.1429 10.8722 16.7591 11.25 16.2857 11.25H8.28572C7.81236 11.25 7.42857 10.8722 7.42857 10.4062ZM8.28572 6.75C7.81236 6.75 7.42857 7.12779 7.42857 7.59375C7.42857 8.05971 7.81236 8.4375 8.28572 8.4375H16.2857C16.7591 8.4375 17.1429 8.05971 17.1429 7.59375C17.1429 7.12779 16.7591 6.75 16.2857 6.75H8.28572ZM7.42857 4.78125C7.42857 4.31529 7.81236 3.9375 8.28572 3.9375H16.2857C16.7591 3.9375 17.1429 4.31529 17.1429 4.78125C17.1429 5.24721 16.7591 5.625 16.2857 5.625H8.28572C7.81236 5.625 7.42857 5.24721 7.42857 4.78125Z"
                          fill="#D3D6DE"
                        />
                        <path
                          d="M0.571429 2.8125C0.255859 2.8125 0 3.06436 0 3.375V16.3125C0 17.2445 0.767578 18 1.71429 18C2.66099 18 3.42857 17.2445 3.42857 16.3125V3.375C3.42857 3.06436 3.17271 2.8125 2.85714 2.8125H0.571429Z"
                          fill="#D3D6DE"
                        />
                      </svg>
                    </span>
                    {collapsed ? "Articles" : "Articles"}
                  </Link>
                )}
              </li>
              <li>
                {hasComplianceAuth && (
                  <Link
                    style={{ position: "relative" }}
                    className={
                      location.pathname === "/dashboard/compliance"
                        ? "active"
                        : ""
                    }
                    to="/dashboard/compliance"
                  >
                    <span className="menu-icon">
                      {/* <em className="icon-compliance"></em> */}
                      <svg 
                        width="22"
                        height="22"
                        viewBox="0 0 384 512"
                        // fill="#ffffff"
                        xmlns="http://www.w3.org/2000/svg">
                        <path 
                          fill="#D3D6DE" 
                          d="M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"
                        />
                      </svg>
                    </span>
                    Compliance
                    <span className="beta-tag" style={{right: 0}}>Beta</span>
                    {complianceUnreadMessageCount !== undefined && parseInt(complianceUnreadMessageCount) > 0 &&
                      <>
                        <span className="short ms-auto short-notifc-number notifc-number">{frmatUnreadMessageCount(complianceUnreadMessageCount)}</span>
                        <span className="long ms-auto notifc-number">{frmatUnreadMessageCount(complianceUnreadMessageCount)}</span>
                      </>
                    }
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
